(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('AreaCalculationService', AreaCalculationService);

    AreaCalculationService.$inject = ['$log'];

    function AreaCalculationService($log) {
        var service = {
            calculateAreaPrice: calculateAreaPrice
        };

        function calculateAreaPrice(prices, squaremeters) {
            $log.debug('AreaCalculationService | calculating area price');

            if (typeof squaremeters === 'string' || squaremeters instanceof String) {
                squaremeters = parseFloat(squaremeters);
            }

            var calcType = prices.calculationType;
            var disposalFee = prices.disposalFee;
            $log.debug('AreaCalculationService | disposalFee found', disposalFee);

            $log.debug('AreaCalculationService | Calculation type: ', calcType);
            if (calcType == 'SCALED_PRICE_PER_SQUARE_METER') {
                var totalSquaremeters = squaremeters;
                var totalPrice = 0;
                totalPrice += squaremeters * disposalFee;
                prices.prices = sortArray(prices.prices, 'minRange');

                angular.forEach(prices.prices, function (value) {

                    var max = value.maxRange;
                    var min = value.minRange;
                    var price = value.price;

                    var isInCompleteInterval = totalSquaremeters > max && max != 0;

                    if (isInCompleteInterval) {
                        totalPrice += (max - min) * price;
                    } else {
                        if (totalSquaremeters > min) {
                            totalPrice += (totalSquaremeters - min) * price;
                        }
                    }

                });

                $log.debug('AreaCalculationService | SCALED_PRICE_PER_SQUARE_METER price', totalPrice);
                return totalPrice;
            } else if (calcType == 'FIXED_PRICE_PER_SQUARE_METER') {
                var totalPrice = prices.prices[0].price * squaremeters;
                totalPrice += squaremeters * disposalFee;
                $log.debug('AreaCalculationService | FIXED_PRICE_PER_SQUARE_METER price', totalPrice);
                return totalPrice;
            } else if (calcType == 'SCALED_PRICE_PER_UNIT_AREA_INCLUDED') {
                var totalPrice = 0;
                angular.forEach(prices.prices, function (value) {

                    var max = value.maxRange;
                    var min = value.minRange;
                    var price = value.price;


                    if (squaremeters >= min && squaremeters <= max) {
                        totalPrice = squaremeters * price;
                        $log.debug('AreaCalculationService | SCALED_PRICE_PER_UNIT_AREA_INCLUDED price', totalPrice);
                        return totalPrice;
                    }else if(squaremeters>min && max ==0){
                        totalPrice = squaremeters * price;
                        $log.debug('AreaCalculationService | SCALED_PRICE_PER_UNIT_AREA_INCLUDED price', totalPrice);
                        return totalPrice;
                    }
                });

                return totalPrice;
            }
        }

        function sortArray(input, attribute) {
            if (!angular.isObject(input)) return input;

            var array = [];
            for (var objectKey in input) {
                array.push(input[objectKey]);
            }

            array.sort(function (a, b) {
                a = parseInt(a[attribute]);
                b = parseInt(b[attribute]);
                return a - b;
            });

            $log.debug('AreaCalculationService | Array sortiert');
            $log.debug(array);
            return array;
        }

        return service;

    }
})();
